export default __webpack_public_path__ + "locales/lo-LA/JavascriptSdk.json?hash=8e6df4ee5b69b475055c46c9dbd1ddba";